const MODAL_TRIGGER_EXCEPTIONS = [
  'MISSING_BILLING_EXCEPTION',
  'POLICY_STATE_GENERIC_EXCEPTION',
  'COVERAGE_SESSION_GENERIC_EXCEPTION',
  'NO_CHANGE_IN_COVERAGE',
  'PAYMENT_ISSUE',
  'COVERAGE_SESSION_GENERIC_EXCEPTION',
  'COVERAGE_VALIDATION_FAILURE',
  'EMAIL_VALIDATION_FAILURE',
  'INRULE_VALIDATION_ERROR',
  'RENEWAL_TOO_CLOSE'
]

const showModal = ref(false)
const isInCoverageFlow = ref(false)

const shouldShowModal = (error: any, options?: { suppress?: boolean }): boolean => {
  if (options?.suppress) {
    return false
  }
  const errorType = error?.title

  if (!errorType) {
    return false
  }

  return MODAL_TRIGGER_EXCEPTIONS.includes(errorType)
}

const showErrorModal = async (inCoverageFlow = false) => {
  isInCoverageFlow.value = inCoverageFlow

  // If we're in a coverage flow, immediately clean up the session when showing the modal
  // This prevents users from refreshing and bypassing the error state
  if (inCoverageFlow) {
    try {
      const { deleteSession, $reset } = useAddPetReduceCoverageStore()
      await deleteSession()
      $reset()
    } catch (error) {
      console.error('Failed to clean up coverage session:', error)
      // Continue showing modal even if cleanup fails
    }
  }

  showModal.value = true
}

const hideErrorModal = () => {
  showModal.value = false
  isInCoverageFlow.value = false
}

const goToHome = () => {
  // Session cleanup already happened in showErrorModal, just navigate
  hideErrorModal()
  navigateTo('/home')
}

export const useGlobalErrorModal = () => {
  return {
    showModal: readonly(showModal),
    isInCoverageFlow: readonly(isInCoverageFlow),
    shouldShowModal,
    showErrorModal,
    hideErrorModal,
    goToHome,
    MODAL_TRIGGER_EXCEPTIONS: readonly(MODAL_TRIGGER_EXCEPTIONS)
  }
}
